export const getHSQ = () => {
	window._hsq = window._hsq || [];

	return window._hsq;
};
